t = require('views/internal/teacup-with-helpers')('org_detail_profile_edit')

module.exports = ->
  t.p '.error.js-profile-form-error.hide'

  t.label ->
    t.format 'name'
  t.input { type: 'text', name: 'displayName', value: t.mustacheVar('displayName'), dir: 'auto' }

  t.label ->
    t.format 'short-name'
  t.input { type: 'text', name: 'name', value: t.mustacheVar('name') }

  t.label ->
    t.format 'website'
  t.input { type: 'text', name: 'website', value: t.mustacheVar('website') }

  t.label ->
    t.format 'description-optional'
  t.textarea { name: 'desc', dir: 'auto' }, ->
    t.text t.mustacheVar('desc')

  t.input '.primary.wide.js-submit-profile', { type: 'submit', value: t.l('save') }
  t.input '.js-cancel-edit-profile', { type: 'button', value: t.l('cancel') }



// WEBPACK FOOTER //
// ./app/scripts/views/templates/org_detail_profile_edit.coffee